import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import DataProvider from '../../app/data-framework/data-provider';
import FilterManager from '../../app/helpers/filter-manager';
import LogiCommon from '../../app/data-framework/logi-common';
import templateMarkup from 'raw-loader!./capacity-details-view.html';
import LoginService from "../../services/login.service";

    var TYPE_MAP = {
        system: {
            viewId: 'historical2capacitydetails',
            title: 'Capacity Details'
        },
        cluster: {
            viewId: 'historical2clustercapacitydetails',
            title: 'Cluster Capacity Details'
        },
        trunk: {
            viewId: 'historical2trunkcapacitydetails',
            title: 'Trunk Capacity Details'
        },
        concurrentCalls: {
            viewId: 'concurrentCallsCapacityDetails',
            title: 'Concurrent Call Details'
        },
        concurrentBandwidth: {
            viewId: 'concurrentBandwidthCapacityDetails',
            title: 'Concurrent Bandwidth Details'
        },
        sysConcurrentMeetingPeakBySysType: {
            viewId: 'sysConcurrentMeetingPeakBySysTypeCapacityDetails',
            title: 'Concurrent Meeting Details'
        },
        sysConcurrentMeetingPeakBySysName: {
            viewId: 'sysConcurrentMeetingPeakBySysNameCapacityDetails',
            title: 'Concurrent Meeting Details'
        },
        sysTypeConcurrentMeetingPeak: {
            viewId: 'sysTypeConcurrentMeetingPeakCapacityDetails',
            title: 'Concurrent Meeting Details'
        }
    };

    function getViewId(type) {
        var viewId = _.get(TYPE_MAP, [type, 'viewId']);
        if (!viewId) {
            throw new Error('Could not find type \'' + type + '\'');
        }
        return TYPE_MAP[type].viewId;
    }

    function getTitle(type) {
        var title = _.get(TYPE_MAP, [type, 'title']);
        if (!title) {
            throw new Error('Could not find type \'' + type + '\'');
        }
        return TYPE_MAP[type].title;
    }

    function CapacityDetailsView(params) {
        var self = this;
        var link = params.route().link;

        self.dataProvider = DataProvider.getInstance();
        self.dataProvider.loadFlexQueryMetadata();

        self.route = params.route;
        self.routeParams = params.route().params;
        self.type = params.route().type;
        self.title = getTitle(self.type);
        self.deviceName = ko.observable();

        self.viewId = getViewId(self.type);
        self.timeZone = {
            id: _.get(LoginService.userObject, 'timezoneId', ''),
            text: _.get(LoginService.userObject, 'timezoneDisplay', '')
        };

        self.logiCommon = new LogiCommon();
        self.urlParams = null;

        self.selectedDateRangeValues = ko.observable(getDateRange());
        self.selectedDataFilter = ko.observable();

        self.capacityDateTime = ko.observable('');

        self.isLoaded = false;

        if (link) {
            self.processLink(link);

        } else {
            self.processRouteParameters();
        }

        self.viewLevelOptions = ko.pureComputed({
            read: function () {
                var result = self.logiCommon.GetHistoricalViewLevelOptions2(
                    null, self.selectedDateRangeValues(), self.urlParams, self.selectedDataFilter()
                );
                if (self.isLoaded) {
                    result.capacityDateTime = self.capacityDateTime();
                    return result;
                }
                return null;
            },

            write: function (capacitydatetime) {
                self.capacityDateTime(capacitydatetime);
            },

            owner: self

        }).extend({ notify: 'always' });
    }

    CapacityDetailsView.prototype = {
        setDeviceName: function() {
            var self = this;
            self.deviceName((self.type === 'cluster')
                ? self.getClusterName()
                : self.getNameFromFilter()
            );
        },

        getNameFromFilter: function() {
            var self = this;
            return _.get(self.selectedDataFilter(), '[0].conditions[0].rhsText', '');
        },

        getClusterName: function() {
            var self = this;
            var name = '';

            _.forEach(self.selectedDataFilter(), function(dataFilter) {
                var clusterNameCondition = _.find(dataFilter.conditions, function(condition) {
                    return condition.selectedLhs === 'dimcluster.clustername';
                });

                if (_.has(clusterNameCondition, 'rhsText')) {
                    name = _.toUpper(clusterNameCondition.rhsText);
                    return false; // exit forEach loop
                }
            });

            return name;
        },

        processLink: function(token) {
            var self = this;

            self.dataProvider
                .getTokenParams(token)
                .then(function (tokenParams) {
                    if (tokenParams) {
                        self.selectedDateRangeValues({
                            startDate: moment(tokenParams.inpStartDate, 'YYYY/MM/DD'),
                            endDate: moment(tokenParams.inpEndDate, 'YYYY/MM/DD')
                        });

                        if (_.isArray(tokenParams.WhereConditionObj)) {
                            // remove start and end time from conditions array, otherwise graph data fails to load
                            if (!_.isEmpty(tokenParams.WhereConditionObj)) {
                                _.remove(tokenParams.WhereConditionObj[0].conditions,
                                    function (cond) {
                                        return _.includes(cond.selectedLhs, 'starttime') || _.includes(cond.selectedLhs, 'endtime');
                                    });
                            }
                            self.selectedDataFilter(tokenParams.WhereConditionObj);
                        }
                        self.setDeviceName();

                    } else {
                        alert('Invalid link');
                    }

                    self.isLoaded = true;
                    self.selectedDataFilter.valueHasMutated();
                });
        },

        processRouteParameters: function() {
            var self = this;

            if (self.routeParams) {
                self.urlParams = self.logiCommon.getParamsObject(self.routeParams);

                if (self.urlParams.inpstartdate && self.urlParams.inpenddate) {
                    self.selectedDateRangeValues({
                        startDate: moment(self.logiCommon.removeTimePortion(self.urlParams.inpstartdate)),
                        endDate: moment(self.logiCommon.removeTimePortion(self.urlParams.inpenddate))
                    });
                }

                var filters = [];
                if (self.urlParams.hasFilters === 'true') {
                    filters = FilterManager.getCurrentFilters();
                    if (filters.inpStartDate && filters.inpEndDate) {
                        self.selectedDateRangeValues({
                            startDate: moment(self.logiCommon.removeTimePortion(filters.inpStartDate)),
                            endDate: moment(self.logiCommon.removeTimePortion(filters.inpEndDate))
                        });
                    }
                }

                if (self.urlParams.WhereCondition) {
                    self.selectedDataFilter(
                        self.urlParams.WhereCondition
                    );

                    self.setDeviceName();
                } else {
                    self.selectedDataFilter(filters.WhereConditionObj);

                    self.setDeviceName();
                }
            }

            self.isLoaded = true;
            self.selectedDataFilter.valueHasMutated();
        }
    };

    function getDateRange() {
        var end = moment().endOf('month');
        var start = moment().startOf('month');

        if (end.get('date') !== moment().get('date')) {
            end = moment().subtract(1, 'month').endOf('month');
            start = moment().subtract(1, 'month').startOf('month');
        }
        return { startDate: start, endDate: end };
    }

    export default { template: templateMarkup, viewModel: CapacityDetailsView };
